// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import { getWhatsappChatSummary, getWhatsappChatDetail, getAllDashboard } from '/src/@api/dashboard'
import { generateMockData } from 'src/utils'
import { addDeviceSwitchReset } from 'src/store/apps/deviceSwitchHandlers'
import { selectDeviceRequestKey } from 'src/store/apps/Common'

// ** Fetch User Profile

const createInitialState = () => ({
  userWxId: '',
  userWxIdList: '',
  leftTotalCount: 0,
  rightTotalCount: 0,
  members: [],
  selectedMessage: {
    contact: {},
    selected: []
  },
  list: [],
  preViewImage: {
    open: false,
    url: ''
  },
  flag: false,
  advanced: true,
  fetchLoading: true,
  leftPage: 0,
  rightPage: 1,
  summaryPending: false,
  deviceRequestKey: '',
  activeSummaryRequestId: '',
  activeDetailRequestId: '',
  activeUserRequestId: ''
})

// SUMMARY
const fetchUserProfileRequest = createAsyncThunk('WeChat/fetchUserProfile', async ({ page, requestKey }) => {
  let firstData = []
  let rightTotalCount = 0

  const username = JSON.parse(localStorage.getItem('DeviceUser')) != null
    ? JSON.parse(localStorage.getItem('DeviceUser')).username
    : ''

  let response = await getAllDashboard({
    username,
    params: {
      category: 'WECHAT_CHAT_SUMMARY',
      offset: (page - 1) * 50,
      limit: 50,
      deviceUdid:
        JSON.parse(localStorage.getItem('currentDevice')) != null
          ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
          : ''
    }
  })

  let advanced = username == null || !('advanced' in response) || ['true', true].includes(response?.advanced) // 高级服务开通状态

  if (Array.isArray(response.data.contents) && response.data.contents.length > 0) {
    response.data.contents = response.data.contents.sort((x, y) => y.totalCount - x.totalCount)

    if (!advanced) { // 未开通高级服务
      response.data.contents[0].sessions = generateMockData(response.data.contents[0].sessions).map((item, index) => {
        if (index === 0) return item

        return { ...item, wxid: index }
      })
    }

    // 判断是不是群信息 获取成员信息
    let chatroom = response.data.contents.length > 0 ? response.data.contents[0].wxid : ''
    let indexof = chatroom.indexOf('@')
    chatroom = chatroom.substr(indexof + 1, chatroom.length)

    let members = []
    if (chatroom == 'chatroom') {
      let getMembers = await getAllDashboard({
        username,
        params: {
          category: 'WECHAT_GROUP_MEMBERS',
          offset: 0,
          limit: 2000,
          deviceUdid:
            JSON.parse(localStorage.getItem('currentDevice')) != null
              ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
              : '',
          userID: response.data.contents.length > 0 ? response.data.contents[0].wxid : '',
          rid: response.data.contents.length > 0 ? response.data.contents[0].sessions[0].chatid : ''
        }
      })
      if (getMembers.data.contents != null) {
        members = getMembers.data.contents
      } else {
        members = []
      }
    }

    if (page === 1) {
      let defaultSelectData = await getAllDashboard({
        username,
        params: {
          category: 'WECHAT_CHAT_DETAIL',
          offset: 0,
          limit: 50,
          deviceUdid:
            JSON.parse(localStorage.getItem('currentDevice')) != null
              ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
              : '',
          userID: response.data.contents.length > 0 ? response.data.contents[0].wxid : '',
          rid: response.data.contents.length > 0 ? response.data.contents[0].sessions[0].chatid : ''
        }
      })

      if (defaultSelectData.data.contents !== null) {
        firstData = defaultSelectData.data.contents.map(row => {
          if (row.messageType === 34) {
            return { ...row, attachment: { url: row.attachment.url + '.mp3' } }
          } else { return { ...row } }
        }).reverse()

        rightTotalCount = defaultSelectData.data.totalCount
      }
    }

    const userId = response.data.contents[0].wxid
    response.data.contents[0].sessions = response.data.contents[0].sessions.map(item => ({ ...item, userWxId: userId }))

    let userWxIdList =
      response.data.contents == null
        ? []
        : response.data.contents.map(row => {
          return {
            value: row.wxid,
            label: row.wxid
          }
        })

    return {
      data: response.data.contents[0].sessions,
      defaultSelectData: firstData,
      leftPage: page,
      leftTotalCount: response.data.contents[0].totalCount,
      rightTotalCount,
      userWxId: response.data.contents[0].wxid,
      userWxIdList,
      members,
      advanced,
      requestKey
    }
  }

  return {
    data: [],
    defaultSelectData: [],
    leftPage: 0,
    leftTotalCount: 0,
    rightTotalCount: 0,
    userWxId: '',
    userWxIdList: [],
    members: [],
    advanced,
    requestKey
  }
})

export const fetchUserProfile = () => (dispatch, getState) => {
  const state = getState()
  const current = state.WeChat
  if (current.summaryPending) return Promise.resolve()

  // 已拉完全部会话，避免触底反复请求
  if (current.leftPage > 0 && current.leftTotalCount > 0 && current.list.length >= current.leftTotalCount) {
    return Promise.resolve()
  }

  const requestKey = selectDeviceRequestKey(state)

  return dispatch(fetchUserProfileRequest({
    page: current.leftPage + 1,
    requestKey
  })).then(action => {
    const latest = getState()
    if (
      fetchUserProfileRequest.fulfilled.match(action) &&
      action.payload.leftPage === 1 &&
      selectDeviceRequestKey(latest) === requestKey &&
      latest.WeChat.activeSummaryRequestId === action.meta.requestId
    ) {
      localStorage.setItem('weChatItem', JSON.stringify(action.payload.data[0] ?? ''))
    }

    return action
  })
}

// 切换用户
const switchUserRequest = createAsyncThunk('WeChat/switchUser', async ({ userId, requestKey }) => {
  const response = await getAllDashboard({
    username:
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : '',
    params: {
      category: 'WECHAT_CHAT_SUMMARY',
      offset: 0,
      limit: 50,
      deviceUdid:
        JSON.parse(localStorage.getItem('currentDevice')) != null
          ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
          : ''
    }
  })

  if (response.data.contents.length > 0) {
    response.data.contents = response.data.contents.sort((x, y) => y.totalCount - x.totalCount)
  }

  let defaultSelectData = await getAllDashboard({
    username:
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : '',
    params: {
      category: 'WECHAT_CHAT_DETAIL',
      offset: 0,
      limit: 50,
      deviceUdid:
        JSON.parse(localStorage.getItem('currentDevice')) != null
          ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
          : '',
      userID: userId,
      rid: response.data.contents.length > 0 ? response.data.contents[0].sessions[0].chatid : ''
    }
  })

  let selected = response.data.contents.find(row => row.wxid == userId)

  return {
    leftTotalCount: selected.totalCount,
    wxid: selected.wxid,
    data: selected.sessions == null ? [] : selected.sessions,
    defaultSelectData: defaultSelectData.data.contents == null ? [] : defaultSelectData.data.contents.reverse(),
    rightTotalCount: defaultSelectData.data.totalCount,
    requestKey
  }
})

export const switchUser = userId => (dispatch, getState) => {
  const state = getState()

  return dispatch(switchUserRequest({ userId, requestKey: selectDeviceRequestKey(state) }))
}

// ** Select Message

const selectChatRequest = createAsyncThunk(
  'WeChat/selectChat',
  async ({ contact, page, requestKey }) => {
  const PK = contact.chatid

  // 判断是不是群信息 获取成员信息
  let chatroom = contact.wxid
  let indexof = chatroom.indexOf('@')
  chatroom = chatroom.substr(indexof + 1, chatroom.length)

  let members = []
  if (chatroom == 'chatroom') {
    let getMembers = await getAllDashboard({
      username:
        JSON.parse(localStorage.getItem('DeviceUser')) != null
          ? JSON.parse(localStorage.getItem('DeviceUser')).username
          : '',
      params: {
        category: 'WECHAT_GROUP_MEMBERS',
        offset: 0,
        limit: 2000,
        deviceUdid:
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : '',
        userID: contact.userWxId,
        rid: PK
      }
    })
    if (getMembers.data.contents != null) {
      members = getMembers.data.contents
    } else {
      members = []
    }
  }

  let response = await getAllDashboard({
    username:
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : '',
    params: {
      category: 'WECHAT_CHAT_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      deviceUdid:
        JSON.parse(localStorage.getItem('currentDevice')) != null
          ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
          : '',
      userID: contact.userWxId,
      rid: PK
    }
  })

  return {
    contact,
    selected:
      response.data.contents == null
        ? []
        : response.data.contents
          .map(row => {
            if (row.messageType === 34) {
              return {
                ...row,
                attachment: {
                  url: row.attachment.url + '.mp3'
                }
              }
            } else {
              return {
                ...row
              }
            }
          })
          .reverse(),
    rightTotalCount: response.data.totalCount,
    members,
    page,
    requestKey
  }
  }
)

export const selectChat = obj => (dispatch, getState) => {
  const state = getState()
  const current = state.WeChat
  let contact = obj || current.selectedMessage.contact
  if (!contact?.chatid) contact = JSON.parse(localStorage.getItem('weChatItem') || '{}')
  if (!contact?.chatid) return Promise.resolve()

  return dispatch(selectChatRequest({
    contact,
    page: obj ? 1 : current.rightPage + 1,
    requestKey: selectDeviceRequestKey(state)
  }))
}

export const setPerViewImage = createAsyncThunk('WeChat/setPerView', async (obj, { dispatch }) => {
  return obj
})

export const loadingStatus = createAsyncThunk('WeChat/loadingStatus', async (obj, { dispatch }) => {
  return true
})

export const appChatSlice = createSlice({
  name: 'WeChat',
  initialState: createInitialState(),
  reducers: {
    removeSelectedChat: state => {
      state.selectedChat = null
    }
  },
  extraReducers: builder => {
    addDeviceSwitchReset(builder, createInitialState)

    builder.addCase(switchUserRequest.pending, (state, action) => {
      state.deviceRequestKey = action.meta.arg.requestKey
      state.activeUserRequestId = action.meta.requestId
      state.activeDetailRequestId = ''
    })
    builder.addCase(switchUserRequest.fulfilled, (state, action) => {
      if (
        state.deviceRequestKey !== action.meta.arg.requestKey ||
        state.activeUserRequestId !== action.meta.requestId
      ) return
      state.userWxId = action.payload.wxid

      state.list = action.payload.data
      state.selectedMessage = {
        contact: action.payload.data.length > 0 ? action.payload.data[0] : {},
        selected: action.payload.defaultSelectData
      }

      state.leftTotalCount = action.payload.leftTotalCount
      state.rightTotalCount = action.payload.rightTotalCount
      state.leftPage = 1
      state.rightPage = 1
    })

    builder.addCase(fetchUserProfileRequest.pending, (state, action) => { // 数据获取中
      // 仅首屏全页 loading；分页用 summaryPending 在列表底部转圈
      if (action.meta.arg.page === 1) {
        state.fetchLoading = true
      }
      state.summaryPending = true
      state.deviceRequestKey = action.meta.arg.requestKey
      state.activeSummaryRequestId = action.meta.requestId
    })

    builder.addCase(fetchUserProfileRequest.fulfilled, (state, action) => {
      if (
        state.deviceRequestKey !== action.meta.arg.requestKey ||
        state.activeSummaryRequestId !== action.meta.requestId
      ) return
      const advanced = action.payload.advanced === true || action.payload.advanced === 'true'
      if (advanced && action.payload.leftPage === 1) {
        state.list = [...action.payload.data]
      } else if (advanced) {
        state.list = [...state.list, ...action.payload.data]
      } else {
        state.list = [...action.payload.data]
      }
      state.leftPage = advanced ? action.payload.leftPage : 0

      state.userWxId = action.payload.userWxId
      state.userWxIdList = action.payload.userWxIdList
      state.rightTotalCount = action.payload.rightTotalCount

      if (
        advanced &&
        action.payload.leftPage > 1 &&
        (!action.payload.data || action.payload.data.length === 0)
      ) {
        state.leftTotalCount = state.list.length
      } else {
        state.leftTotalCount = action.payload.leftTotalCount
      }
      if (action.payload.leftPage === 1) {
        state.selectedMessage = { contact: action.payload.data[0], selected: action.payload.defaultSelectData }
      }
      state.members = action.payload.members
      state.advanced = advanced
      state.fetchLoading = false
      state.summaryPending = false
    })
    builder.addCase(fetchUserProfileRequest.rejected, (state, action) => {
      if (
        state.deviceRequestKey === action.meta.arg.requestKey &&
        state.activeSummaryRequestId === action.meta.requestId
      ) {
        state.fetchLoading = false
        state.summaryPending = false
      }
    })

    builder.addCase(selectChatRequest.pending, (state, action) => {
      state.deviceRequestKey = action.meta.arg.requestKey
      state.activeDetailRequestId = action.meta.requestId
      state.activeUserRequestId = ''
    })
    builder.addCase(selectChatRequest.fulfilled, (state, action) => {
      if (
        state.deviceRequestKey !== action.meta.arg.requestKey ||
        state.activeDetailRequestId !== action.meta.requestId
      ) return
      state.members = action.payload.members
      if (action.payload.page > 1 && state.selectedMessage.contact.chatid == action.payload.contact.chatid) {
        state.selectedMessage.selected = [...state.selectedMessage.selected, ...action.payload.selected]
      } else {
        state.selectedMessage.selected = action.payload.selected
      }

      state.selectedMessage.contact = action.payload.contact

      state.rightTotalCount = action.payload.rightTotalCount
      state.rightPage = action.payload.page

      state.flag = false
    })

    builder.addCase(setPerViewImage.fulfilled, (state, action) => {
      state.preViewImage = action.payload
    })

    builder.addCase(loadingStatus.fulfilled, (state, action) => {
      state.flag = true
    })
  }
})

export const { removeSelectedChat } = appChatSlice.actions

export default appChatSlice.reducer
